import React from 'react'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { getHtml } from '../../../helpers/html';

/**
 * @typedef {{name: string; type: ('text/html' | 'application/pdf' | 'application/tif' | 'application/jpg'); html?: string; url?: string}} Attachment
 */

/**
 * 
 * @param {{
 *   lang: string;
 *   isOpen: boolean;
 *   onClose: () => void;
 *   attachments: Attachment[];
 * }} props 
 * @returns 
 */
const LabPortalenAttachmentsModal = (props) => {
	const attachments = props.attachments;
	return (
		<Modal
			isOpen={props.isOpen}
			toggle={props.onClose}
			size='xxl'
			centered
		>
			<ModalBody>
				{attachments.length === 1
					? <Attachment {...attachments[0]} />
					: <ul style={{ listStyleType: 'none', padding: 0, width: '100%' }}>
						{attachments.map(attachment => <li key={attachment.name + attachment.type} style={{ marginBottom: '20px', width: '100%' }}>
							<Attachment {...attachment} />
						</li>)}
					</ul>
				}
			</ModalBody>
			<ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }}>
				<Button
					color="primary"
					onClick={props.onClose}
					style={{ minWidth: '100px' }}
				>
					{'Close'.translate(props.lang)}
				</Button>
			</ModalFooter>
		</Modal>
	)
}

export default LabPortalenAttachmentsModal

/**
 * 
 * @param {Attachment} param0 
 */
const Attachment = ({ name, type, html, url }) => {
	if (type === 'text/html' && html) {
		const htmlContent = getHtml(html);
		return <div dangerouslySetInnerHTML={{ __html: htmlContent }} style={{ whiteSpace: 'pre-wrap' }} />
	} else if (url) {
		return <iframe src={url} style={{ width: '100%', height: '600px' }} title={name} />
	}

	return <></>
}